import { ApiProperty } from '@nestjs/swagger';
import { IsOptional } from 'class-validator';

import { SpConnectJobInterface } from '../interfaces/sp-connect-job.interface';

export class SpConnectJobDto implements SpConnectJobInterface {
  @ApiProperty()
  @IsOptional()
  subdivision?: string;

  @ApiProperty()
  @IsOptional()
  plan?: string;

  @ApiProperty()
  @IsOptional()
  lot?: string;

  @ApiProperty()
  @IsOptional()
  block?: string;

  @ApiProperty()
  @IsOptional()
  street?: string;

  @ApiProperty()
  @IsOptional()
  streetSupplement?: string;

  @ApiProperty()
  @IsOptional()
  city?: string;

  @ApiProperty()
  @IsOptional()
  stateCode?: string;

  @ApiProperty()
  @IsOptional()
  postalCode?: string;
}
